import {
  FC,
  JSXElementConstructor,
  PropsWithChildren,
  ReactElement,
} from "react";
import { Box, Divider, Typography } from "@mui/material";
import TooltipInfo from "src/Pages/Company/Absences/Forms/TooltipInfo";

interface IFieldsetProps {
  legend: string;
  description?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  helpText?: ReactElement<any, string | JSXElementConstructor<any>>;
  divider?: boolean;
  required?: boolean;
}

const Fieldset: FC<PropsWithChildren<IFieldsetProps>> = ({
  legend,
  helpText,
  description,
  children,
  divider = true,
  required = false,
}) => (
  <Box
    component="fieldset"
    sx={{ border: "none", marginBottom: divider ? 0 : "1.5rem" }}
  >
    <Typography
      variant="subtitle1"
      component="legend"
      sx={{ marginBottom: "1rem" }}
    >
      {legend} {required && "*"}
      {helpText && <TooltipInfo title={helpText} />}
    </Typography>
    {description && (
      <Typography variant="body2" mb="1rem">
        {description}
      </Typography>
    )}
    <Box>{children}</Box>
    {divider && <Divider sx={{ margin: "1.5rem 0" }} />}
  </Box>
);

export default Fieldset;
